'use strict';

require('../../style/index.less');

require('../../layout/style/index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/col/style/index.tsx
 ** module id = 289
 ** module chunks = 0
 **/